import type { LucideIcon, LucideProps } from "lucide-react";

export interface IconProps extends Omit<LucideProps, "size" | "strokeWidth" | "ref"> {
  /** The Lucide glyph, imported by name from `lucide-react`. */
  readonly icon: LucideIcon;
  /** 16 px in lists and controls, 20 px in navigation (ADR 0022). */
  readonly size?: 16 | 20;
  /** What the icon means when nothing beside it says so; without it the icon is decorative and hidden from readers. */
  readonly label?: string;
}

/** Meridian's icons: Lucide's outline set at a 1.75 stroke, in the text's color. */
export function Icon({ icon: Glyph, size = 16, label, ...props }: IconProps) {
  return label === undefined ? (
    <Glyph size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" {...props} />
  ) : (
    <Glyph size={size} strokeWidth={1.75} role="img" aria-label={label} focusable="false" {...props} />
  );
}
